'use strict';

frontendApp.factory('AuthorizationRefreshService', ['$rootScope', '$log', '$location', 'TokenService', 'NotificationService', 'authService',
  function ($rootScope, $log, $location, TokenService, NotificationService, authService) {

    // Listen once per app lifetime (factory registration ensures that)
    $rootScope.$on('event:invalid-token', function () {
      // If we don't have a token, jump straight to login
      if (!TokenService.Exists()) {
        TokenService.Clear();
        $location.path('/');
        return;
      }

      // TokenService sets/clears $rootScope.refreshingToken; use it to avoid refresh storms
      if ($rootScope.refreshingToken) return;

      TokenService.Refresh()
        .then(function success() {
          // New token is stored; replay buffered requests
          authService.loginConfirmed();
        })
        .catch(function failure() {
          TokenService.Clear();
          $location.path('/');
          NotificationService.addError({
            title: 'Logged out',
            description: 'Your login has expired. Please log in again.'
          });
        });
    });

    return {};
}]);
